import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import backgroundVideo from '../../assets/images/Whisk_uzm4atzzqdz0etnl1iz1uwotkdzlrtllfwzl1in.mp4';
import styles from './HeroCarousel.module.css';

const HeroCarousel = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.heroCarousel}>
      {/* Video Background */}
      <div className={styles.videoContainer}>
        <video
          className={styles.backgroundVideo}
          autoPlay
          loop
          muted
          playsInline
        >
          <source src={backgroundVideo} type="video/mp4" />
        </video>
        {/* Gradient Overlay */}
        <div className={styles.overlay}></div>
      </div>

      {/* Content */}
      <div className={styles.content}>
        <div className={styles.contentInner}>
          <h1 className={styles.title}>
            <span className={styles.titleLine1}>{t('hero.titleLine1')}</span>
            <span className={styles.titleLine2}>{t('hero.titleLine2')}</span>
          </h1>
          <p className={styles.subtitle}>
            {t('hero.subtitle')}
          </p>
          <Link to="/about" className={styles.readMoreBtn}>
            <span>{t('hero.readMore') || 'Read More'}</span>
            <svg
              className={styles.btnIcon}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </Link>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className={styles.scrollIndicator}>
        <div className={styles.scrollMouse}>
          <div className={styles.scrollWheel}></div>
        </div>
        <span className={styles.scrollText}>{t('hero.scroll') || 'Scroll Down'}</span>
      </div>
    </div>
  );
};

export default HeroCarousel;

